// Cartel Clean — global behaviors

// Loader with brand logo + page slide transitions
setTimeout(() => document.body.classList.add('loaded'), 420);
document.addEventListener('click', (e) => {
  const a = e.target.closest('a');
  if (!a || a.hasAttribute('data-no-transition') || a.target === '_blank') return;
  const href = a.getAttribute('href') || '';
  // only internal navigation, skip anchors and JS links
  if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;
  if (a.origin && a.origin !== location.origin) return;
  e.preventDefault();
  document.body.classList.remove('loaded');
  document.body.classList.add('page-leave');
  setTimeout(() => { location.href = a.href; }, 300);
});
window.addEventListener('pageshow', (e) => {
  if (e.persisted) {
    document.body.classList.remove('page-leave');
    document.body.classList.add('loaded');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  // Mobile menu
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Hero slider dots + autoplay
  document.querySelectorAll('[data-hero]').forEach((hero) => {
    const track = hero.querySelector('.hero-slider');
    const slides = track ? Array.from(track.children) : [];
    const dotsWrap = hero.querySelector('.hero-dots');
    if (!track || slides.length < 2) return;

    const dots = slides.map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', `Slide ${i + 1}`);
      b.addEventListener('click', () => {
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      });
      dotsWrap.appendChild(b);
      return b;
    });

    const setActive = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
    };
    track.addEventListener('scroll', () => requestAnimationFrame(setActive), { passive: true });
    setActive();
  });

  // Product form: variant resolution
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variants = JSON.parse(form.querySelector('[data-variants]').textContent);
    const idInput = form.querySelector('input[name="id"]');
    const priceEl = document.querySelector('[data-product-price]');
    const button = form.querySelector('[data-add-button]');
    const btnDefault = button ? button.dataset.labelAdd : '';
    const btnSoldOut = button ? button.dataset.labelSold : '';

    const currentOptions = () =>
      Array.from(form.querySelectorAll('[data-option-index]'))
        .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex)
        .map((group) => {
          const checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        });

    const sync = () => {
      const opts = currentOptions();
      const match = variants.find((v) =>
        opts.every((val, i) => val === null || v.options[i] === val)
      );
      if (!match) return;
      idInput.value = match.id;
      if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available ? btnDefault : btnSoldOut;
      }
    };

    form.querySelectorAll('.option-values input').forEach((input) =>
      input.addEventListener('change', sync)
    );
    sync();
  });

  // Locale switcher
  document.querySelectorAll('[data-locale-select]').forEach((select) => {
    select.addEventListener('change', () => select.closest('form').submit());
  });
});
